import { createStore, getAllStore, storeTransfer, updateStore } from '../../AllRoutes/ApiRoute';
import CommonAxios from '../../Utilities/CommonAxios';
import CommonLoader from '../../Utilities/CommonLoader';
import CommonToast from '../../Utilities/CommonToast';
import StoreSlice from '../Slice/StoreSlice';

// get all stores action accounts
export const getAllStoresAction = (payload) => (dispatch) => {
  // getting data form payload
  const { allStoreTableLoaderRef } = payload;
  // handle loader
  CommonLoader.section(allStoreTableLoaderRef);
  // db operation
  CommonAxios.silentPost(getAllStore, payload)
    .then((res) => {
      // handle loader
      CommonLoader.section(allStoreTableLoaderRef);
      if (res.data.status == true) {
        dispatch(StoreSlice.actions.getAllStoresReducer(res.data?.data || []));
      }
    })
    .catch((err) => {
      // handle loader
      CommonLoader.section(allStoreTableLoaderRef);
    });
};

// get store from dropdown action
export const getStoreForDropdown = (payload) => (dispatch) => {
  const { setMyStores, setIsLoading } = payload;
  // handle loader
  setIsLoading(true);
  // db operation
  CommonAxios.silentPost(getAllStore, payload)
    .then((res) => {
      // handle loader
      setIsLoading(false);
      if (res.data.status == true) {
        setMyStores(res.data?.data || []);
      }
    })
    .catch((err) => {
      // handle loader
      setIsLoading(false);
    });
};

// add store action
export const addStoreAction = (payload) => (dispatch) => {
  // getting data from payload
  let { setForceToFetchData, submitRef, setAddModalShow } = payload;
  // loader handle
  CommonLoader.btn(submitRef);
  // db operation
  CommonAxios.post(createStore, payload)
    .then((res) => {
      // loader handle
      CommonLoader.btn(submitRef);
      if (res.data.status == true) {
        setAddModalShow(false);
        setForceToFetchData((prev) => !prev);
        // toast
        CommonToast.success('Store successfully created.');
      } else {
        // toast
        CommonToast.error('Store create failed.');
      }
    })
    .catch((err) => {
      // loader handle
      CommonLoader.btn(submitRef);
    });
};

// update store action
export const updateStoreAction = (payload) => (dispatch) => {
  // getting data from payload
  let { setForceToFetchData, submitRef, setUpdateModalShow } = payload;
  // loader handle
  CommonLoader.btn(submitRef);
  // db operation
  CommonAxios.post(updateStore, payload)
    .then((res) => {
      // loader handle
      CommonLoader.btn(submitRef);
      if (res.data.status == true) {
        setUpdateModalShow(false);
        setForceToFetchData((prev) => !prev);
        // toast
        CommonToast.success('Store successfully updated.');
      } else {
        // toast
        CommonToast.error('Store update failed.');
      }
    })
    .catch((err) => {
      // loader handle
      CommonLoader.btn(submitRef);
    });
};

// store transfer action
export const storeTransferAction = (payload) => (dispatch) => {
  // getting data from payload
  const { data, reset, storeTransferBtnRef, chalanGetForUdpateAndReturnOnSubmit, chalanGetFieldRef } = payload;

  // return button loader handle
  CommonLoader.btn(storeTransferBtnRef);

  // db operation
  CommonAxios.post(storeTransfer, payload)
    .then((res) => {
      // return button loader handle
      CommonLoader.btn(storeTransferBtnRef);

      if (res.data.status == true) {
        // get this chalan and set to the form again in updated possition
        chalanGetFieldRef.current.value = data.chalan_no;
        chalanGetForUdpateAndReturnOnSubmit();
        reset();
        // toast message
        CommonToast.success(res?.data?.message || 'Store transferred!');
      } else {
        // toast message
        CommonToast.error(res?.data?.message || 'Store transfer failed!');
      }
    })
    .catch((err) => {
      // return button loader handle
      CommonLoader.btn(storeTransferBtnRef);
    });
};
